import { combineReducers } from 'redux'

import { pageReducer } from './page/reducer'
import { loginReducer } from './login/reducer'
import { sessionReducer } from './session/reducer'
import { menuReducer } from './menu/reducer'
import { menuV2 } from './user_menu/reducer'
import { menuEditor } from './menu_editor/reducer'
import { collectionsReducer } from './collections/reducer'
import { appealsReducer } from './appeals/reducer'
import { viewedReducer } from './viewed/reducer'
import { hrReducer } from './hr/reducer'
import { appeal } from './appeal/reducer'
import { order } from './order/reducer'
import { calendar } from './calendar/reducer'
import { chatAvitoReducer } from './chat_avito/reducer'
import { ordersDetailReducer } from './ordersDetail/reducer'
import { deliveries } from './deliveries/reducer'
import { timelineReducer } from './timeline/reducer'
import { stagePlanReducer } from './stagePlan/reducer'
import { measurementReducer } from './measurement/reducer'
import { montageReducer } from './montage/reducer'
import { historyChangesReducer } from './history/reducer'
import { claimRequestReducer } from './claim_request/reducer'
import { claimReducer } from './claim/reducer'
import { claimWorkReducer } from './claim_work/reducer'

export const reducers = combineReducers({
  page: pageReducer,
  login: loginReducer,
  session: sessionReducer,
  menu: menuReducer,
  menuV2: menuV2,
  menuEditor: menuEditor,
  collections: collectionsReducer,
  appeals: appealsReducer,
  viewed: viewedReducer,
  hr: hrReducer,
  appeal: appeal,
  order: order,
  calendar: calendar,
  chatAvito: chatAvitoReducer,
  ordersDetail: ordersDetailReducer,
  deliveries: deliveries,
  timeline: timelineReducer,
  stagePlan: stagePlanReducer,
  measurement: measurementReducer,
  montage: montageReducer,
  history: historyChangesReducer,
  claimRequest: claimRequestReducer,
  claim: claimReducer,
  claimWork: claimWorkReducer,
})

